import { render, staticRenderFns } from "./ApiDocs.vue?vue&type=template&id=25a0984a&scoped=true"
import script from "./ApiDocs.vue?vue&type=script&lang=js"
export * from "./ApiDocs.vue?vue&type=script&lang=js"
import style0 from "./ApiDocs.vue?vue&type=style&index=0&id=25a0984a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25a0984a",
  null
  
)

export default component.exports